import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  grey200,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_3xl,
  font_family_weight_medium,
  font_md,
  fontRegular,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.InsightsPage {
    max-height: 100%;
    .InsightsPage-columns {
      display: flex;
      height: 100%;
      overflow: hidden;

      .InsightsPage-left {
        width: 420px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-right: 1px solid ${base_colorContentBorder};
        background: ${base_colorRaisedSurface};
        overflow-y: auto;
      }

      .InsightsPage-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;
        background: ${grey200};
        overflow-y: auto;

        .InsightsPage-right-title {
          flex-shrink: 0;
          padding: ${spacing(5)};
          font-family: ${font_family_weight_medium};
          ${font_3xl};
        }

        .InsightsPage-right-content {
          flex: 1;
          padding: ${spacing(5)};
          display: flex;
          flex-direction: column;
          gap: ${spacing(4)};

          .InsightsPage-right-pinned {
            display: flex;
            flex-direction: column;
            gap: ${spacing(3)};

            .InsightsPage-right-pinned-title {
              font-family: ${font_family_weight_medium};
              ${font_md};
              color: ${text_colorTextSecondary};
            }
          }
        }

        .InsightsPage-right-empty {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: ${spacing(10)};
          text-align: center;
          ${fontRegular};
          color: ${text_colorTextSecondary};
        }

        .InsightsPage-right-data {
          display: flex;
          flex-direction: column;
          gap: ${spacing(3)};

          .InsightsPage-right-data-header {
            display: flex;
            flex-direction: column;
            gap: ${spacing(1)};

            h3 {
              margin: 0;
              font-family: ${font_family_weight_medium};
              font-size: 20px;
            }

            .InsightsPage-right-data-endpoint {
              font-size: 12px;
              color: ${text_colorTextSecondary};
              font-family: monospace;
            }
          }

          .InsightsPage-right-data-loading,
          .InsightsPage-right-data-error {
            padding: ${spacing(4)};
            background: ${base_colorRaisedSurface};
            border-radius: 8px;
            ${fontRegular};
          }

          .InsightsPage-right-data-error {
            color: #d32f2f;
          }

          .InsightsPage-right-data-content {
            background: ${base_colorRaisedSurface};
            border-radius: 8px;
            padding: ${spacing(4)};
            overflow: auto;

            .InsightsPage-right-data-json {
              margin: 0;
              font-family: monospace;
              font-size: 12px;
              line-height: 1.5;
              white-space: pre-wrap;
              word-break: break-word;
            }
          }
        }
      }
    }
  }
`
